import type { SanityPageBuilderIntroDetailsSection, SanityPageBuilderSection } from "@ouster/shared";
import { IntroDetailsBlockView, type IntroDetailsItemView } from "~/features/blocks/inventory/intro-details";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderIntroDetailsSection;
  };
};
export function SanityIntroDetailsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const details = sectionContent.details?.map<IntroDetailsItemView>(detail => ({
    baseLink: detail.baseLink,
    label: detail.label,
    text: detail.text
  })) ?? [];
  return <IntroDetailsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} details={details} headline={sectionContent.headline} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}